import api from "./../api";
import UtilsUrl from "../../utils/UtilsUrl";

class JournalCaisseService {
  validateJournauxByCaisse(
    cashRegisterId,
    userId,
    idTotalIncome,
    creationDateIncome
  ) {
    return api.get(
      UtilsUrl.JournalCaissePosURL() +
        "/validateJournauxByCaisse/" +
        cashRegisterId +
        "/" +
        userId +
        "/" +
        idTotalIncome +
        "/" +
        creationDateIncome
    );
  }
  getAllJournauxByCaisseAndUser(
    cashRegisterId,
    userId,
    dateDebutToFilter,
    dateFinToFilter
  ) {
    return api.get(
      UtilsUrl.JournalCaissePosURL() +
        "/getAllJournauxByCaisseAndUser/" +
        cashRegisterId +
        "/" +
        userId,
      {
        params: {
          dateDebutToFilter: dateDebutToFilter,
          dateFinToFilter: dateFinToFilter,
        },
      }
    );
  }
  getAllJournauxByCaisse(cashRegisterId, dateDebutToFilter, dateFinToFilter) {
    return api.get(
      UtilsUrl.JournalCaissePosURL() +
        "/getAllJournauxByCaisse/" +
        cashRegisterId,
      {
        params: {
          dateDebutToFilter: dateDebutToFilter,
          dateFinToFilter: dateFinToFilter,
        },
      }
    );
  }

  getAllJournauxByShop(idShop, dateDebutToFilter, dateFinToFilter) {
    return api.get(
      UtilsUrl.JournalCaissePosURL() + "/getAllJournauxByShop/" + idShop,
      {
        params: {
          dateDebutToFilter: dateDebutToFilter,
          dateFinToFilter: dateFinToFilter,
        },
      }
    );
  }

  getAllPayementJournaleShop(idShop, dateDebutToFilter, dateFinToFilter) {
    return api.get(
      UtilsUrl.JournalCaissePosURL() + "/getAllPayementJournaleShop/" + idShop,
      {
        params: {
          dateDebutToFilter: dateDebutToFilter,
          dateFinToFilter: dateFinToFilter,
        },
      }
    );
  }
  getAllPayementJournaleCaisse(
    cashRegisterId,
    dateDebutToFilter,
    dateFinToFilter
  ) {
    return api.get(
      UtilsUrl.JournalCaissePosURL() +
        "/getAllPayementJournaleCaisse/" +
        cashRegisterId,
      {
        params: {
          dateDebutToFilter: dateDebutToFilter,
          dateFinToFilter: dateFinToFilter,
        },
      }
    );
  }
}
export default new JournalCaisseService();
